/**
 * Auth0 Configuration for Web App
 */

export const auth0Config = {
  domain: import.meta.env.VITE_AUTH0_DOMAIN || '',
  clientId: import.meta.env.VITE_AUTH0_CLIENT_ID || '',
  audience: import.meta.env.VITE_AUTH0_AUDIENCE || '',
  redirectUri: import.meta.env.VITE_AUTH0_REDIRECT_URI || window.location.origin + '/auth/callback',
  logoutUri: import.meta.env.VITE_AUTH0_LOGOUT_URI || window.location.origin,
  scope: 'openid profile email offline_access', // offline_access for refresh tokens
};

// Validate configuration
export const validateAuth0Config = (): boolean => {
  const required = ['domain', 'clientId', 'audience'];
  const missing = required.filter(key => !auth0Config[key as keyof typeof auth0Config]);

  if (missing.length > 0) {
    console.error(`Missing required Auth0 configuration in Web App: ${missing.join(', ')}`);
    return false;
  }

  console.log('Auth0 configuration validated successfully in Web App');
  return true;
};

// Log configuration on load (without secrets)
console.log('Auth0 Configuration loaded in Web App:', {
  domain: auth0Config.domain,
  audience: auth0Config.audience,
  redirectUri: auth0Config.redirectUri,
});
